/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1NotificationMobileAppNotificationidPreview200,
  GetApiV1NotificationMobileAppNotificationidPreview401,
  GetApiV1NotificationMobileAppNotificationidPreview404,
  GetApiV1NotificationMobileAppNotificationidPreview500,
  GetApiV1NotificationMobileAppNotificationidPreviewPathParams,
  GetApiV1NotificationMobileAppNotificationidPreviewQueryResponse,
} from "../../types/notificationMobileAppController/GetApiV1NotificationMobileAppNotificationidPreview.ts";
import { mobileNotificationPreviewViewModelSchema } from "../mobileNotificationPreviewViewModelSchema.ts";

export const getApiV1NotificationMobileAppNotificationidPreviewPathParamsSchema =
  z.object({
    notificationId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1NotificationMobileAppNotificationidPreviewPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1NotificationMobileAppNotificationidPreview200Schema =
  z.lazy(
    () => mobileNotificationPreviewViewModelSchema,
  ) as unknown as ToZod<GetApiV1NotificationMobileAppNotificationidPreview200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1NotificationMobileAppNotificationidPreview401Schema =
  z.any() as unknown as ToZod<GetApiV1NotificationMobileAppNotificationidPreview401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1NotificationMobileAppNotificationidPreview404Schema =
  z.any() as unknown as ToZod<GetApiV1NotificationMobileAppNotificationidPreview404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1NotificationMobileAppNotificationidPreview500Schema =
  z.any() as unknown as ToZod<GetApiV1NotificationMobileAppNotificationidPreview500>;

export const getApiV1NotificationMobileAppNotificationidPreviewQueryResponseSchema =
  z.lazy(
    () => getApiV1NotificationMobileAppNotificationidPreview200Schema,
  ) as unknown as ToZod<GetApiV1NotificationMobileAppNotificationidPreviewQueryResponse>;
